import { IItemForGetShortInfo, ITotalPrice } from 'types';
import React, { useCallback, useMemo } from 'react';
import MultipleSelect from './components/MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './IsDisabledField.module.scss';

interface IIsDisabledField {
	setDisabledInRestaurants: (value: string[]) => void;
	isDisabledInRestaurants: string[];
	totalPrices: ITotalPrice[];
	fetchedRestaurants: IItemForGetShortInfo[];
}

const IsDisabledField: React.FC<IIsDisabledField> = ({
	isDisabledInRestaurants,
	totalPrices,
	fetchedRestaurants,
	setDisabledInRestaurants,
}) => {
	const handleRemove = useCallback(
		(id: string) => {
			const updatedSelectedItems = isDisabledInRestaurants.filter((el) => el !== id);
			setDisabledInRestaurants(updatedSelectedItems);
		},
		[isDisabledInRestaurants, setDisabledInRestaurants],
	);

	const restaurantsList = useMemo(() => {
		return isDisabledInRestaurants.map((el) => {
			const label = fetchedRestaurants.find((rest) => rest.id === el)?.name || '';
			return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
		});
	}, [isDisabledInRestaurants, fetchedRestaurants]);

	return (
		<div className={style.container} data-test="IsDisabledField">
			<div className={style.field}>
				<MultipleSelect
					totalPrices={totalPrices}
					isDisabledInRestaurants={isDisabledInRestaurants}
					setDisabledInRestaurants={setDisabledInRestaurants}
				/>
			</div>
			<div className={style.restaurantsList}>{restaurantsList}</div>
		</div>
	);
};

export default React.memo(IsDisabledField);
